import { connect } from 'react-redux';
import { withI18n } from 'react-i18next';
import { withRouter } from 'react-router';

import MyOrders from './MyOrders';

import { IInitialState } from 'src/store/initialState';
import {
  ordersSel,
  ordersPageNumberSel,
  ordersPageSizeSel,
  ordersTotalElementsSel,
  ordersTotalPagesSel,
  ordersIsPendingSel,
  ordersActions
} from 'src/store/modules/orders';

interface IDispatchFromProps {
  onSearch(
    dateFrom?: string,
    dateTo?: string,
    search?: string,
    sort?: string,
    status?: string,
    size?: number,
    page?: number
  ): void;
  cancelOrder(
    orderNumber: number,
    items: { [key: number]: string },
    currentOrdersData: {
      dateFrom?: string;
      dateTo?: string;
      search?: string;
      sort?: string;
      status?: string;
      size?: number;
      page?: number;
    }
  ): void;
}

const mapStateToProps = (state: IInitialState) => ({
  orders: ordersSel(state),
  pageNumber: ordersPageNumberSel(state),
  pageSize: ordersPageSizeSel(state),
  totalElements: ordersTotalElementsSel(state),
  totalPages: ordersTotalPagesSel(state),
  isPending: ordersIsPendingSel(state)
});

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onSearch: (
    dateFrom?: string,
    dateTo?: string,
    search?: string,
    sort?: string,
    status?: string,
    size?: number,
    page?: number
  ) => {
    dispatch(
      ordersActions.getInfo(dateFrom, dateTo, search, sort, status, size, page)
    );
  },
  cancelOrder: (
    orderNumber: number,
    items: { [key: number]: string },
    currentOrdersData: {
      dateFrom?: string;
      dateTo?: string;
      search?: string;
      sort?: string;
      status?: string;
      size?: number;
      page?: number;
    }
  ) => {
    dispatch(ordersActions.cancelOrder(orderNumber, items, currentOrdersData));
  }
});

export const pureComponent = MyOrders;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(withRouter(MyOrders)));
